import { number } from 'prop-types';
import React from 'react';
import { GoCircleSlash } from 'react-icons/go';

import CurrencyFormat from '../../generic/CurrencyFormat';

function DeltaLabel({ target, current, spent }) {
  if (target < spent) {
    return <GoCircleSlash />;
  }

  if (target !== current) {
    return (
      <CurrencyFormat value={target - current} className="text-nowrap" text />
    );
  }
  return null;
}

DeltaLabel.propTypes = {
  target: number.isRequired,
  current: number,
  spent: number,
};

DeltaLabel.defaultProps = {
  current: 0,
  spent: 0,
};

export default DeltaLabel;
